// for localhost development
// export let BASE_URL = "http://localhost/kebab-junction-laravel-rest-api";
// for live development
export let BASE_URL = "https://api.meenatchicafe.com";
// export let BASE_URL = "https://kebabapi.petalyellow.com/testing";  

